__webpack_require__.p = "https://svum.test.perfectstay.io/static/";